import React, { useEffect, useState, useImperativeHandle, forwardRef, useRef } from "react";
import HttpService from "../../../services/HttpService";

const FilterManager = forwardRef(({ interfaceId }, ref) => {
    // filters can have status "new", "synced", "updated" or "deleted"
    const [filters, setFilters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [axios, setAxios] = useState(null);
    const axiosRef = useRef(null);

    // Expose methods to parent through ref
    useImperativeHandle(ref, () => ({
        SaveFilters
    }));

    useEffect(() => {
        if (!interfaceId) {
            setLoading(false);
            return;
        }

        const fetchFilters = async (axiosClient) => {
            try {
                let url = process.env.REACT_APP_API_URL + "/Interfaces/errorfilters/" + interfaceId;
                const response = await axiosClient.get(url);
                setFilters(
                    Object.entries(response.data).map(([id, value]) => ({
                        id,
                        value,
                        localId: id,
                        status: "synced"
                    }))
                );
            } catch (err) {
                console.error("Failed to fetch filters", err);
            } finally {
                setLoading(false);
            }
        };

        const httpService = HttpService;
        httpService.configure();
        let axiosClient = httpService.getAxiosClient();
        axiosRef.current = axiosClient;
        setAxios(axiosClient);

        fetchFilters(axiosClient);
    }, [interfaceId]);

    const SaveFilters = async () => {
        let newFilters = filters.filter(f => f.status === "new");
        let deletedFilters = filters.filter(f => f.status === "deleted");

        //add new filters
        const values = newFilters.map(f => f.value); // only get values
        const csvContent = values.join(",");

        // try {
        //   const res = await fetch(`${url+ "/" + interfaceId}`, {
        //     method: "POST",
        //     headers: { "Content-Type": "text/plain" },
        //     body: csvContent,
        //   });

        //   const created = await res.json();
        //   setFilters((prev) => [...prev, created]);
        // } catch (err) {
        //   console.error("Failed to add filter", err);
        // }
        let url = process.env.REACT_APP_API_URL + "/Interfaces/errorfilters/" + interfaceId;
        var config = {
            headers: {
                'Content-Type': 'text/plain'
            }
        };
        axiosRef.current.post(url, csvContent, config)
            .then((response) => {
            })
            .catch((err) => {
                console.error("Failed to save filters", err);
            })

        //remove deleted filters
        // for (let i = 0; i < deletedFilters.length; i++) {
        //   const filter = deletedFilters[i];
        //   try {
        //     await fetch(`${url}/${filter.id}`, { method: "DELETE" });
        //     setFilters((prev) => prev.filter((f) => f.id !== filter.id));
        //   } catch (err) {
        //     console.error("Failed to delete filter", err);
        //   }
        // }
        for (let i = 0; i < deletedFilters.length; i++) {
            const filter = deletedFilters[i];
            let url = process.env.REACT_APP_API_URL + "/Interfaces/errorfilters/" + filter.id;
            axiosRef.current.delete(url)
                .then((response) => {
                    // If the delete was successful, remove the filter from state
                    setFilters((prev) => prev.filter((f) => f.localId !== filter.localId));
                })
                .catch((err) => {
                    console.error("Failed to delete filter", err);
                });
        }
    };

    const addFilter = async () => {
        const localId = `temp-${Date.now()}`;
        setFilters((prev) => [
            ...prev,
            { value: "", localId, status: "new" }
        ]);
    };

    const updateFilter = async (id, newValue) => {
        if (filters.some(f => f.localId === id && f.status === "new")) {
            // If the filter is marked as new, it should not be set to "updated"
            setFilters((prev) =>
                prev.map((filter) =>
                    filter.localId === id
                        ? { ...filter, value: newValue }
                        : filter
                )
            );
        }
        else {
            setFilters((prev) =>
                prev.map((filter) =>
                    filter.localId === id
                        ? { ...filter, value: newValue, status: "updated" }
                        : filter
                )
            );
        }
    };

    const removeFilter = async (id) => {
        filters.forEach((filter) => {
            if (filter.localId === id) {
                if (filter.status === "new") {
                    // remove immediately if it's a new filter
                    setFilters((prev) => prev.filter((f) => f.localId !== id));
                } else {
                    // mark as deleted if it's synced or updated
                    setFilters((prev) =>
                        // keep all the same exept if the id matches, then change status to deleted
                        prev.map((f) =>
                            f.localId === id ? { ...f, status: "deleted" } : f
                        )
                    );
                }
            }
        })
    };

    if (loading) return <div>Loading filters...</div>;

    return (
        <div className="p-4 space-y-2">
            {filters.filter((filter) => filter.status !== "deleted").map((filter) => (
                <div key={filter.localId} className="flex items-center space-x-2">
                    <input
                        type="text"
                        className="border p-2 rounded w-full"
                        value={filter.value}
                        onChange={(e) => updateFilter(filter.localId, e.target.value)}
                    />
                    <button
                        onClick={() => removeFilter(filter.localId)}
                        className="bg-red-500 text-white px-2 py-1 rounded"
                    >
                        Remove
                    </button>
                </div>
            ))}
            <button
                onClick={addFilter}
                className="bg-blue-500 text-white px-4 py-2 rounded mt-4"
            >
                Add Filter
            </button>
        </div>
    );
});

export default FilterManager;
